import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Zap, Infinity as InfinityIcon } from 'lucide-react';
export function HeroSection() {
  return <section className="relative pt-20 pb-16 md:pt-28 md:pb-24 px-4 overflow-hidden bg-cream" data-id="element-56">
      <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-12 items-center" data-id="element-57">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="space-y-8" data-id="element-58">
          <div className="inline-block bg-orange-light text-orange font-semibold px-4 py-1.5 rounded-full text-sm tracking-wide" data-id="element-59">
            🔥 Precio Especial de Lanzamiento
          </div>

          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-forest leading-tight" data-id="element-60">
            Vientre Plano SOS: El Reseteo de 24 Horas
          </h1>

          <p className="text-xl md:text-2xl text-charcoal-light font-serif italic" data-id="element-61">
            Desactiva la inflamación abdominal y recupera tu figura en un solo
            día (Sin dietas eternas ni laxantes agresivos).
          </p>

          <div className="pt-4" data-id="element-62">
            <a href="#pricing" className="block w-full md:w-auto text-center bg-orange hover:bg-orange-hover text-white font-bold text-lg py-4 px-8 rounded-xl shadow-lg hover:shadow-xl transform hover:-translate-y-1 transition-all duration-300" data-id="element-63">
              ¡QUIERO MI RESETEO DE 24 HORAS AHORA!
            </a>

            <div className="mt-4 flex flex-wrap justify-center md:justify-start gap-4 text-sm text-charcoal-light font-medium" data-id="element-64">
              <div className="flex items-center gap-1.5" data-id="element-65">
                <ShieldCheck className="w-4 h-4 text-forest" data-id="element-66" />
                <span data-id="element-67">Pago Seguro</span>
              </div>
              <div className="flex items-center gap-1.5" data-id="element-68">
                <Zap className="w-4 h-4 text-forest" data-id="element-69" />
                <span data-id="element-70">Acceso Inmediato</span>
              </div>
              <div className="flex items-center gap-1.5" data-id="element-71">
                <InfinityIcon className="w-4 h-4 text-forest" data-id="element-72" />
                <span data-id="element-73">Acceso de por Vida</span>
              </div>
            </div>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="relative" data-id="element-74">
          <div className="absolute inset-0 bg-forest-100 rounded-3xl transform rotate-3 scale-105 -z-10" data-id="element-75"></div>
          <img src="https://cdn.magicpatterns.com/uploads/4vmRUZZohKYxJpn4LCgNNo/vientre_plano_2_.png" alt="Vientre Plano SOS: El Reseteo de 24 Horas" className="w-full h-auto rounded-2xl shadow-2xl object-cover" data-id="element-76" />
        </motion.div>
      </div>
    </section>;
}